import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Controller, FormContext, useForm } from 'react-hook-form'
import { FormControlLabel, Grid, Switch, TextField } from '@material-ui/core'

import { BaseDialog, LoadingFeedback, UserTypeAndSearchInput } from 'components'

import { useSnackbar } from 'hooks'

import helpers from 'helpers'
import * as service from 'service'

import schema from './schema'

const ChangeResponsibleDialog = ({
  organizationId,
  open,
  setOpen = () => {},
  refresh = () => {},
}) => {
  const [selectExistentResponsible, setSelectExistentResponsible] =
    useState(false)
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      selectExistentResponsible: false,
      responsibleDpo: '',
      responsibleName: '',
      responsibleEmail: '',
    },
  })

  const { handleSubmit, errors, control, register, reset } = formMethods

  const onSubmit = async (data) => {
    setLoading(true)

    const organization = data.selectExistentResponsible
      ? {
          selectExistentResponsible: true,
          responsibleDpo: data.responsibleDpo,
        }
      : {
          selectExistentResponsible: false,
          responsibleName: data.responsibleName,
          responsibleEmail: data.responsibleEmail,
        }

    try {
      await service.backoffice.organizations.changeDPO({
        organizationId,
        organization,
      })

      snackbar.open({
        message: 'Responsável alterado com sucesso!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setOpen(false)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      setSelectExistentResponsible(false)
      reset({
        selectExistentResponsible: false,
        responsibleDpo: '',
        responsibleName: '',
        responsibleEmail: '',
      })
    }
  }, [open, reset])

  return (
    <>
      <LoadingFeedback open={loading} />
      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Alteração de Responsável"
        closeButtonText="Cancelar"
        actionButtonText="Alterar"
        dialogSize="sm"
        formRef="change-responsible-form"
        noMargin
        justifyActions="flex-end"
        actionButton={handleSubmit(onSubmit)}
      >
        <FormContext {...formMethods}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={selectExistentResponsible}
                    color="primary"
                    onChange={(e) => {
                      setSelectExistentResponsible(e.target.checked)
                    }}
                  />
                }
                inputRef={register}
                name="selectExistentResponsible"
                label="Usuário existente"
              />
            </Grid>
            {selectExistentResponsible ? (
              <Grid item xs={12}>
                <UserTypeAndSearchInput
                  label="Email do Responsável"
                  fieldName="responsibleDpo"
                  searchField="email"
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} md={6}>
                  <Controller
                    as={
                      <TextField
                        fullWidth
                        error={!!errors.responsibleName}
                        helperText={errors?.responsibleName?.message}
                        label="Nome do responsável"
                      />
                    }
                    control={control}
                    name="responsibleName"
                    mode="onBlur"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    as={
                      <TextField
                        fullWidth
                        error={!!errors.responsibleEmail}
                        helperText={errors?.responsibleEmail?.message}
                        label="E-mail do responsável"
                      />
                    }
                    control={control}
                    name="responsibleEmail"
                    mode="onBlur"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </FormContext>
      </BaseDialog>
    </>
  )
}

ChangeResponsibleDialog.propTypes = {
  organizationId: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  setLoading: PropTypes.func,
}

export default ChangeResponsibleDialog
